import { css } from "@emotion/react";
import { Common } from "@src/styles/Common";
import React from "react";

interface Props {
    step: number;
    isPrev: boolean;
    isNext: boolean;
    isShowList: boolean;
    canGoNext: boolean;
    isSaving?: boolean;
    isReset?: boolean;
    onClickReset?: () => void;
    onClickPrev: () => void;
    onClickNext: () => void;
    onClickShowList: () => void;
    style?: React.CSSProperties;
}

const FavoriteRegionFooter = ({
    step,
    isPrev,
    isNext,
    isShowList,
    canGoNext,
    isSaving = false,
    isReset,
    onClickReset,
    onClickPrev,
    onClickNext,
    onClickShowList,
    style,
}: Props) => {
    return (
        <div css={containerStyle} style={style}>
            {step === 2 && (
                <button type="button" onClick={onClickPrev} className="prev">
                    이전
                </button>
            )}
            {isNext && (
                <button
                    type="button"
                    onClick={onClickNext}
                    style={{ flex: !isPrev ? 2 : 1 }}
                    className={canGoNext && !isSaving ? "next" : "disabled"}
                    disabled={!canGoNext || isSaving}
                >
                    {step === 1 ? "다음" : "저장"}
                </button>
            )}
        </div>
    );
};

export default FavoriteRegionFooter;

const containerStyle = css`
    position: absolute;
    width: calc(100% - 2px);
    bottom: 0;
    margin-left: -13px;
    flex: 1;
    display: flex;
    row-gap: 12px;
    background-color: #ffffff;
    button {
        flex: 1;
        height: 54px;
        border-radius: 14px;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0px;
        text-align: center;
    }
    button + button {
        margin-left: 12px;
    }
    .reset {
        background: #fbf8f8;
        color: #0c002c;
    }
    .prev {
        background: ${Common.colors.bgMint};
    }
    .next {
        background: ${Common.colors.aucMarkerColor};
        color: white;
    }
    .showList {
        background: ${Common.colors.aucMarkerColor};
        color: white;
    }
    .disabled {
        background: #dadada;
        color: #0c002c;
    }
`;
